import 'vue-advanced-chat/dist/vue-advanced-chat.css';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'Chat',
  props: {
    profileId: { required: false },
  },
  data() {
    return {
      roomMessages: [],
      roomMatches: [],
      roomMessagesPage: 1,
      roomMatchesPage: 1,
      fetchingMessagesRooms: false,
      fetchingMatchesRooms: false,
      messages: [],
      messagesLoaded: false,
      loadingRooms: true,
      activeRoom: null,
      randomId: 1,
      isReady: false,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
      isPaymentApproved: 'isPaymentApproved',
    }),
    roomsMatched: {
      get() {
        return this.$store.getters['chat/getShowMatchedTab'];
      },
      set(value) {
        this.$store.commit('chat/setShowMatchedTab', value);
      },
    },
    activeRoomId: function () {
      return this.activeRoom ? this.activeRoom.roomId : null;
    },
    activeRoomProfileId: function () {
      return this.activeRoom ? this.activeRoom.profile_id : null;
    },
    rooms: function () {
      return {
        messages: this.roomMessages,
        matches: this.roomMatches,
        length: this.roomMessages.length + this.roomMatches.length,
      };
    },
    mappedMessages() {
      return this.messages.map((message) => {
        message.sender_id = message.user_id;
        message._id = message.id;

        if (message.media) {
          message.file = {
            type: 'jpg',
            url: message.media.url + (message.media.is_blurred ? '?=blurred' : ''),
          };
        }

        if (message.gift) {
          message.file = {
            type: 'jpg',
            url: message.gift.url,
          };
        }

        return message;
      }).sort((m1, m2) => {
        if (m1.created_at_timestamp > m2.created_at_timestamp) {
          return 1;
        }
        if (m1.created_at_timestamp < m2.created_at_timestamp) {
          return -1;
        }
        if (m1.id > m2.id) {
          return 1;
        }
        if (m1.id < m2.id) {
          return -1;
        }
        return 0;
      });
    },
  },
  watch: {
    'activeRoom': function (activeRoom) {
      if (!activeRoom) {
        return;
      }

      if (!activeRoom.roomId) {
        console.log('Messages 1');
        this.messages = [];
        this.messagesLoaded = true;
      }
    },
    'isReady': function (isReady) {
      if (isReady) {
        setTimeout(() => {
          this.setupScrollListener(true);
        }, 500);
      }
    },
  },
  methods: {
    setupScrollListener(retry = false) {
      /*
       * Rooms list infinity scroll handler
       */
      let ele = document.getElementsByClassName('room-list')[0];

      if (ele) {
        ele.addEventListener('scroll', (() => {
          if ((ele.scrollHeight - ele.clientHeight - 10) < ele.scrollTop) {
            if (this.roomsMatched) {
              this.getMatchesRooms();
            } else {
              this.getMessagesRooms();
            }
          }
        }));
      } else {
        console.log('Chat missing scroll element: ' + retry);

        if (retry) {
          setTimeout(() => {
            this.setupScrollListener(false);
          }, 1200);
        }
      }
    },
    findRoomByProfileId(profileId) {
      return this.rooms.messages.find(room => {
          return profileId === room.profile_id;
        }) ||
        this.rooms.matches.find(room => {
          return profileId === room.profile_id;
        });
    },
    findRoomByRoomId(roomId) {
      return this.rooms.messages.find(room => {
          return roomId === room.roomId;
        }) ||
        this.rooms.matches.find(room => {
          return roomId === room.roomId;
        });
    },
    resetMessages() {
      this.messages = [];
      this.messagesLoaded = false;
      this.randomId = Math.floor(Math.random() * 100000);
    },

    lastMessageId: function () {
      if (this.mappedMessages.length > 0) {
        return Math.min.apply(Math, this.mappedMessages.map(o => o.id));
      }
      return null;
    },
    deleteMessagesAction: function (profileId) {
      const roomId = this.activeRoom ? this.activeRoom.roomId : null;
      profileId = profileId ?? this.activeRoom.profile_id;

      if (roomId) {
        axios
          .delete(zRoute('ajax.chat2.messages.destroy', roomId))
          .then(response => {
            if (response.data.remove_room) {
              this.chatDeleteRoom(profileId);
              this.messages = [];
              if (!this.roomsMatched) {
                this.chatSetActiveFirst();
              }
            } else {
              this.messages = [];
              this.messagesLoaded = true;
              this.activeRoom.lastMessage = null;
            }
          });
      } else {
        this.chatDeleteRoom(profileId);
        this.messages = [];
        if (!this.roomsMatched) {
          this.chatSetActiveFirst();
        }
      }
    },
    chatDeleteRoom: function (profileId) {
      let index = this.roomMessages.findIndex((x) => {
        return x.profile_id === profileId;
      });

      if (index !== -1) {
        this.$delete(this.roomMessages, index);
      }

      if (!this.roomsMatched && this.activeRoom.profile_id === profileId) {
        this.activeRoom = null;
      }
    },
    chatSetActiveRoom: function ({ room, source }) {
      console.log('chatSetActiveRoom source: ', source);

      this.messages = [];
      this.messagesLoaded = false;

      this.activeRoom = null;
      this.isReady = true;

      this.$nextTick(() => {
        this.activeRoom = room;
        this.fetchMessagesDebounced({ room });
      });
    },
    chatSetActiveFirst: function () {
      if (!this.roomMessages || !this.roomMessages[0]) {
        return;
      }

      this.chatSetActiveRoom(this.roomMessages[0]);
    },
    fetchMessagesDebounced: _.debounce(function (roomDto) {
      this.fetchMessages(roomDto);
    }, 100),
    fetchMessages: function ({ room, options = {} }) {
      if (options.reset) {
        this.resetMessages();
      }
      let vm = this;

      if (!room.id) {
        vm.messages = [];
        vm.messagesLoaded = true;
        return;
      }

      this.messagesLoaded = false;

      let messageId = this.lastMessageId();
      axios
        .get(zRoute('ajax.chat2.rooms.messages.index', {
          room: room.id,
          last_message_id: messageId,
          random_id: vm.randomId,
        }))
        .then(response => {
          this.$store.commit('user/setUserUnreadMessagesCount', response.data.unread_messages_count);

          if ((vm.activeRoomId === response.data.room_id) && (response.data.random_id === 0 || vm.randomId === response.data.random_id)) {

            //if we fetch messages in messenger window try to scroll to bottom but only once
            if (vm.messages.length === 0) {
              setTimeout(() => {
                const scrollContainer = document.querySelector('div.col-messages > div.container-scroll.scroll');
                if (scrollContainer) {
                  scrollContainer.scroll({ top: 99999 });
                }
              }, 100);
            }

            let messages = response.data.data;

            vm.messages = vm.messages.concat(messages);

            if (messages.length < 4) {
              vm.messagesLoaded = true;
            }
          }
        });
    },
    fetchMessage: function (messageId) {
      let vm = this;
      return axios
        .get(zRoute('ajax.chat2.messages.show', {
          message: messageId,
        }))
        .then(response => {
          let message = response.data.data;
          if (vm.activeRoomId === message.room_id) {
            vm.messages.push(message);
          }
        });
    },
    deleteMessage: function (messageId) {
      let messageIndex = this.messages.findIndex(message => {
        return message.id === messageId;
      });

      if (messageIndex !== -1) {
        this.messages.splice(messageIndex, 1);
      }
    },
    sendMessage: function ({ content, roomId, profileId, file, replyMessage }) {
      const randomId = Math.floor(Math.random() * 100000);

      if (this.messages.length > 0) {
        this.messages.push({
          id: randomId,
          _id: randomId,
          sender_id: this.user.id,
          user_id: this.user.id,
          content: content,
          randomId: randomId,
          room_id: roomId,
          seen: false,
          created_at_timestamp: moment().unix(),
        });
      }

      let route = roomId ? zRoute('ajax.chat2.rooms.messages.price.store', roomId) : zRoute('ajax.chat2.profiles.messages.store', profileId);

      axios
        .post(route, {
          content: content,
        })
        .then(response => {
          let message = response.data.data;

          let messageIndex = this.messages.findIndex(message => {
            return message.randomId === randomId;
          });

          if (messageIndex === -1) {
            this.messages.push(message);
          } else {
            this.$set(this.messages, messageIndex, message);
          }

          // this.getRoomsDebounced('StoreNewMessage');
          this.getRoom(message.room_id);
        })
        .catch(response => {
          let messageIndex = this.messages.findIndex(message => {
            return message.randomId === randomId;
          });

          if (messageIndex !== -1) {
            this.messages.splice(messageIndex, 1);
          }
        });
    },
    addMessage(message) {
      let vm = this;
      this.getRoom(message.room_id)
        .then(() => {
          if (vm.activeRoomId === message.room_id) {
            vm.messages.push(message);
          } else if (vm.activeRoomProfileId === message.receiver_id) {
            vm.messages.push(message);
          }
        });
    },
    seenMessage: function (message) {
      axios
        .post(zRoute('ajax.chat2.messages.update', {
          message: message.id,
        }));
    },
    roomMapFunction(room) {
      room.roomId = room.id;
      // room.roomId = room.profile_id;
      room.avatar = room.profile.avatar_url;
      room.roomName = room.profile.name;
      room.users = [];

      if (room.message) {
        room.lastMessage = {
          content: room.message.content || '',
          timestamp: this.formatRoomDate(room.message.created_at),
          new: !room.message.seen && (this.user.id !== room.message.user_id),
          seen: room.message.seen,
        };
      }
      return room;
    },
    roomMatchedMapFunction(matched) {
      let room = matched.room || {};
      room.roomId = matched.room_id;
      room.profile_id = matched.profile.id;
      room.profile = matched.profile;
      room.avatar = matched.profile.avatar_url;
      room.roomName = matched.profile.name;

      room.users = [];

      if (room.message) {
        room.lastMessage = {
          content: room.message.content || '',
          timestamp: this.formatRoomDate(room.message.created_at),
          new: !room.message.seen && (this.user.id !== room.message.user_id),
          seen: room.message.seen,
        };
      }

      return room;
    },
    getRooms: function () {
      let promises = [];

      promises.push(this.getMessagesRooms());
      promises.push(this.getMatchesRooms());

      return Promise.all(promises);
    },
    getMessagesRooms: function () {
      if (this.fetchingMessagesRooms) {
        return;
      }
      this.fetchingMessagesRooms = true;

      let page = this.roomMessagesPage++;

      return axios
        .get(zRoute('ajax.chat2.rooms.paginate.index', {
          per_page: 15,
          page: page,
          list: 'messages',
        }))
        .then(response => {
          response.data.data.map(this.roomMapFunction);

          if (page > 1) {
            response.data.data.forEach(room => {
              this.roomMessages.push(room);
            });
          } else {
            this.roomMessages = response.data.data;
          }

          // this.roomMessages = response.data.data;
          this.loadingRooms = false;
          this.fetchingMessagesRooms = false;
          this.$store.commit('user/setUserUnreadMessagesCount', response.data.unread_messages_count);
        });
    },
    getMatchesRooms: function () {
      if (this.fetchingMatchesRooms) {
        return;
      }
      this.fetchingMatchesRooms = true;

      let page = this.roomMatchesPage++;

      return axios
        .get(zRoute('ajax.chat2.rooms.matched.index', {
          per_page: 15,
          page: page,
          list: 'matches',
        }))
        .then(response => {
          let resp = response.data.data.map(this.roomMatchedMapFunction);

          if (page > 1) {
            resp.forEach(room => {
              this.roomMatches.push(room);
            });
          } else {
            this.roomMatches = resp;
          }

          this.fetchingMatchesRooms = false;
        });
    },
    getRoom: function (roomId, event) {
      return axios
        .get(zRoute('ajax.chat2.rooms.show', roomId))
        .then(response => {
          let room = this.roomMapFunction(response.data.data);

          let index = this.roomMessages.findIndex((x) => {
            return x.id === room.id || x.profile_id === room.profile_id;
          });

          if (index === -1) {
            this.roomMessages.unshift(room);
          } else {
            this.$set(this.roomMessages, index, room);
          }

          if (room.is_matched) {
            let index = this.roomMatches.findIndex((x) => {
              return x.id === room.id;
            });

            this.$set(this.roomMatches, index, room);
          }

          if (this.activeRoom && (this.activeRoom.id === room.id || this.activeRoom.profile_id === room.profile_id)) {
            this.activeRoom.id = room.id;
            this.activeRoom.roomId = room.roomId;
          }
        });
    },
    createRoomByProfileId: function (profileId) {
      return axios
        .get(zRoute('ajax.chat2.profiles.rooms.show', profileId))
        .then(response => {
          let room = this.roomMapFunction(response.data.data);

          room.action_at_timestamp = Math.floor(Date.now() / 1000);

          let index = this.roomMessages.findIndex((x) => {
            return x.id === room.id;
          });

          if (index === -1) {
            this.roomMessages.unshift(room);
          } else {
            this.$set(this.roomMessages, index, room);
          }
          return room;
        });
    },

    firstMessage: function (message) {
      this.sendMessage({ content: message, roomId: this.activeRoom.id, profileId: this.activeRoom.profile_id });
    },

    openChat: function (profileId) {
      let vm = this;

      let exist = vm.rooms.messages.findIndex((room) => {
        return room.profile_id === profileId;
      }) !== -1 || vm.rooms.matches.findIndex((room) => {
        return room.profile_id === profileId;
      }) !== -1;

      if (!exist) {
        this.createRoomByProfileId(profileId)
          .then((room) => {
            this.chatSetActiveRoom({ room, source: 'createRoomByProfileId' });
          });
      } else {
        const room = vm.findRoomByProfileId(profileId);

        if (room) {
          vm.activeRoom = null;

          this.$nextTick(() => {
            this.chatSetActiveRoom({ room, source: 'roomNextTick' });
          });
        }
      }
    },

    setListeners() {
      let vm = this;
      Echo.private('user.' + vm.user.id)
        .listen('RoomsUpdate', () => {
        })
        .listen('NewMessageEvent', (event) => {
          if (event.room_id === vm.activeRoomId) {
            vm.fetchMessage(event.message_id)
              .then(() => {
                this.getRoom(event.room_id, 'ListenerNewMessageEvent ActiveRoom');
              });
          } else {
            this.getRoom(event.room_id, 'ListenerNewMessageEvent');
          }
        })
        .listen('NewRoomEvent', (event) => {
          return axios
            .get(zRoute('ajax.chat.rooms.show', event.user.id))
            .then(response => {
              this.getRoom(response.data.data.id, 'ListenerNewRoomEvent');
            });
        })
        .listen('MessageUpdate', () => {
        })
        .listen('MessageDeletedEvent', (event) => {
          if (event.room_id === vm.activeRoomId) {
            this.deleteMessage(event.message_id);
          }
        })
        .listen('MessagesReadEvent', (event) => {
          let messages = event.messages;
          setTimeout(function () {
            messages.forEach((messageId, index) => {
              let m = vm.messages.find((m) => m.id === messageId);

              if (m) {
                m.seen = true;
              }
            });
          }, 1000);
        });
    },
    chatMixinMounted(){
      let vm = this;
      this.$store.dispatch('invitationMessages/load');

      this.getRooms()
        .then(() => {
          /*
           * Open matches tab
           */
          if (window.location.hash && window.location.hash === '#Matches') {
            vm.roomsMatched = true;
          }

          /*
           * Set initial room after load
           */
          if (!this.isMobile || this.profileId)
            setTimeout(() => {
              let room = null;

              if (this.profileId) {
                room = vm.findRoomByProfileId(parseInt(this.profileId));
                if (!room) {
                  this.createRoomByProfileId(this.profileId)
                    .then((room) => {
                      this.chatSetActiveRoom({ room, source: 'createRoomByProfileId' });
                    });

                  return;
                }
              } else if (vm.roomsMatched && this.roomMatches[0]) {
                room = this.roomMatches[0];
              } else if (this.roomMessages[0]) {
                room = this.roomMessages[0];
              }

              if (room) {
                this.chatSetActiveRoom({ room, source: 'setTimeoutRoom' });
              }
            }, 1);
        });

      setTimeout(() => {
        this.isReady = true;
      }, 1000);

      if (vm.user && vm.user.id) {
        vm.setListeners();
      } else {
        this.$eventHub.$on('UserLoaded', function () {
          vm.setListeners();
        });
      }
    },
  },
  mounted() {
  },
  beforeDestroy() {
    Echo.private('user.' + this.user.id)
      .stopListening('RoomsUpdate')
      .stopListening('NewMessageEvent')
      .stopListening('NewRoomEvent')
      .stopListening('MessageUpdate')
      .stopListening('MessagesReadEvent')
      .stopListening('MessageDeletedEvent');
  }
};
